import { useMutation } from "@apollo/client";
import { PaperAirplaneIcon } from "@heroicons/react/24/solid";
import { Button, TextField } from "@mui/material";
import { useState } from "react";
import styled from "styled-components";
import Page from "../../components/Page/Page";
import Panel from "../../components/Panel/Panel";
import { SEND_PUSH } from "../../graphql/mutations-gql";
import { useDismissableSnackbar } from "../../hooks/useDismissableSnackbar";

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
`;

const PushSend = () => {
  const [userId, setUserId] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [actionUrl, setActionUrl] = useState("");
  const { showSnackbar } = useDismissableSnackbar();
  const [sendPush] = useMutation(SEND_PUSH, {
    variables: {
      args: {
        userId,
        title,
        message,
        actionUrl,
      },
    },
    onCompleted: (data) => {
      console.log("sendPush onCompleted", data);
      showSnackbar("Push notification sent successfully.", "success");
    },
    onError: (error) => {
      console.log("sendPush onError", error);
      showSnackbar(
        "Failed to send push notification. " + error.message,
        "error"
      );
    },
  });

  return (
    <Page
      title="Push send"
      description="Send a push notification to a single user."
      maxWidth={640}
    >
      <Panel title="Notification">
        <Form>
          <TextField
            label="User id"
            size="small"
            fullWidth
            value={userId}
            onChange={(event) => setUserId(event.target.value)}
            inputProps={{ spellCheck: false }}
          />
          <TextField
            label="Title"
            size="small"
            fullWidth
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
          <TextField
            label="Message"
            size="small"
            fullWidth
            multiline
            minRows={3}
            value={message}
            onChange={(event) => setMessage(event.target.value)}
          />
          <TextField
            label="Action URL"
            size="small"
            fullWidth
            value={actionUrl}
            onChange={(event) => setActionUrl(event.target.value)}
            inputProps={{ spellCheck: false }}
          />
          <FormActions>
            <Button
              variant="contained"
              startIcon={<PaperAirplaneIcon width={16} />}
              onClick={() => sendPush()}
            >
              Send push
            </Button>
          </FormActions>
        </Form>
      </Panel>
    </Page>
  );
};
export default PushSend;
